import { useSeo } from '../../lib/motion';
import { PAGES } from '../../data/seo';

// Reusable SEO component: render <Seo page="home" /> on any page.
// Pulls title/description/keywords/type from the central PAGES config and
// auto-generates meta description, keywords, canonical, Open Graph and Twitter tags.
// Supports per-page overrides for dynamic/one-off cases.
export default function Seo({ page, title, description, keywords, image, type }) {
  const cfg = (page && PAGES[page]) || {};
  useSeo(title || cfg.title, description || cfg.description, {
    keywords: keywords || cfg.keywords,
    image,
    type: type || cfg.type,
  });
  return null;
}
